module.exports = __webpack_public_path__ + "static/media/empower-logo-box.54868584.png";